import { PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
/**
 * Validates frame placement in PLATSA according to following stacking rules:
 * - 120cm high frames can't be stacked on wall hanging frames
 * - 180cm high frames can only be stacked on floor standing 40 or 60cm high frames
 */
export class PlatsaStackedFrameValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'PlatsaStackedFrameValidation');
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (!entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
            return this.validationOK();
        }
        if (snapActionCandidate.host.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
            return this.validateStackedFrame(entity, snapActionCandidate.host);
        }
        else if (snapActionCandidate.host.hasComponent(ComponentIds.ROOM_PART_COMPONENT_ID) &&
            this.candidateIsWall(snapActionCandidate)) {
            return this.validateWallHangingFrame(entity);
        }
        return this.validationOK();
    }
    validateStackedFrame(guestFrame, hostFrame) {
        const guestHeight = this.coreApi.entities.getEntityComSize(guestFrame)?.height || 0;
        const stackedFramesOnGuest = HierarchyUtils.descendants(guestFrame).filter(child => child.hasComponent(ComponentIds.FRAME_COMPONENT_ID));
        const hostHeight = this.coreApi.entities.getEntityComSize(hostFrame)?.height || 0;
        const stackedFramesOnHost = this.coreApi.entities.getAncestorsWithProductType(hostFrame, ProductType.PLATSA_FRAME);
        const totalHostStackHeight = stackedFramesOnHost.reduce((sum, frame) => sum + (this.coreApi.entities.getEntityComSize(frame)?.height || 0), hostHeight);
        if (this.isFrameWallHanging(hostFrame) && guestHeight >= 1200) {
            return this.validationFail('Cant stack 120 or 180cm high frames on wall hanging frames');
        }
        else if (guestHeight === 1800 && totalHostStackHeight > 1200) {
            return this.validationFail('For safety reasons, cant stack 180cm high frames above 120cm');
        }
        else if (stackedFramesOnGuest.some(frame => (this.coreApi.entities.getEntityComSize(frame)?.height || 0) === 1800)) {
            return this.validationFail('Cant stack frames with stacked 180cm high frames');
        }
        return this.validationOK();
    }
    validateWallHangingFrame(frame) {
        const stackedFrames = HierarchyUtils.descendants(frame).filter(child => child.hasComponent(ComponentIds.FRAME_COMPONENT_ID));
        if (stackedFrames.length === 0) {
            return this.validationOK();
        }
        const stackedFrameHeights = stackedFrames.map(stackedFrame => this.coreApi.entities.getEntityComSize(stackedFrame)?.height || 0);
        return stackedFrameHeights.some(height => height >= 1200)
            ? this.validationFail('Cant wall hang frame with stacked 120 or 180cm high frame')
            : this.validationOK();
    }
    isFrameWallHanging(frame) {
        return !this.coreApi.entities.isPartOfFloorstandingStack(frame);
    }
    candidateIsWall(snapActionCandidate) {
        return snapActionCandidate.hostConnector.offers().includes('wall');
    }
}
//# sourceMappingURL=PlatsaStackedFrameValidation.js.map